import React, { useState, useEffect } from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/24/outline';
import { useTranslation } from 'react-i18next';

const images = [
    '/assets/images/landing/slider1.jpg',
    '/assets/images/landing/slider2.jpg',
    '/assets/images/landing/slider5.jpg',
    '/assets/images/landing/slider3.jpg',
    '/assets/images/landing/slider4.jpg',
    '/assets/images/landing/slider6.jpg',
    '/assets/images/landing/slider7.jpg',
    '/assets/images/landing/slider8.jpg',
];

const ImageCarousel: React.FC = () => {
    const { t } = useTranslation();
    const [currentIndex, setCurrentIndex] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            nextSlide();
        }, 4000);
        return () => clearInterval(interval);
    }, [currentIndex]);

    const nextSlide = () => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    };

    const prevSlide = () => {
        setCurrentIndex((prevIndex) => (prevIndex - 1 + images.length) % images.length);
    };

    return (
        <div className="relative w-full max-w-full md:max-w-5xl lg:max-w-6xl mx-auto">
            {/* Image container */}
            <div className="relative h-[400px] sm:h-[500px] md:h-[600px] lg:h-[700px] overflow-hidden">
                {images.map((src, index) => (
                    <div
                        key={index}
                        className={`absolute inset-0 transition-opacity duration-700 ease-in-out ${index === currentIndex ? 'opacity-100' : 'opacity-0'
                            }`}
                    >
                        <img src={src} alt={`Slider Image ${index + 1}`} className="object-cover w-full h-full" />

                        {/* Image overlay  */}
                        <div className="absolute inset-0 bg-black opacity-30"></div>
                    </div>
                ))}

                {/* Overlay Text */}
                <div className="absolute inset-0 flex flex-col items-center justify-center text-center">
                    <h1 className="text-white text-2xl md:text-4xl font-bold leading-[1.1] mb-4">
                        {t('cw_lp_home_0')}
                    </h1>
                    <div className="mt-4">
                        <h1 className="text-white text-lg md:text-xl font-bold leading-[1.1]">
                            {t('cw_lp_home_1')}
                            <br />
                            {t('cw_lp_home_2')}
                            <br />
                            {t('cw_lp_home_3')}
                        </h1>
                    </div>
                </div>
            </div>

            {/* Left Arrow */}
            <button
                onClick={prevSlide}
                className="absolute top-1/2 left-5 transform -translate-y-1/2 bg-gray-700 text-white rounded-full p-2 hover:bg-gray-600 focus:outline-none"
                aria-label="Previous Slide"
            >
                <ChevronLeftIcon className="h-6 w-6" />
            </button>

            {/* Right Arrow */}
            <button
                onClick={nextSlide}
                className="absolute top-1/2 right-5 transform -translate-y-1/2 bg-gray-700 text-white rounded-full p-2 hover:bg-gray-600 focus:outline-none"
                aria-label="Next Slide"
            >
                <ChevronRightIcon className="h-6 w-6" />
            </button>

            {/* Dots */}
            <div className="absolute bottom-5 left-1/2 transform -translate-x-1/2 flex space-x-2">
                {images.map((_, index) => (
                    <button
                        key={index}
                        className={`w-3 h-3 rounded-full ${currentIndex === index ? 'bg-gray-900' : 'bg-gray-300'
                            }`}
                        onClick={() => setCurrentIndex(index)}
                        aria-label={`Go to slide ${index + 1}`}
                    ></button>
                ))}
            </div>
        </div>
    );
};

export default ImageCarousel;
